import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { BreadcrumbItem } from '../components/breadcrumb/breadcrumb.component';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private navButtonTemplateSubject =
    new BehaviorSubject<TemplateRef<unknown> | null>(null);
  navButtonTemplate$ = this.navButtonTemplateSubject.asObservable();

  private breadcrumbItemsSubject = new BehaviorSubject<BreadcrumbItem[] | null>(
    null,
  );
  breadcrumbItems$ = this.breadcrumbItemsSubject.asObservable();

  private sidebarActionSubject = new Subject<{ action: string }>();
  sidebarAction$ = this.sidebarActionSubject.asObservable();

  setNavButton(template: TemplateRef<unknown>): void {
    this.navButtonTemplateSubject.next(template);
  }

  clearNavButton(): void {
    this.navButtonTemplateSubject.next(null);
  }

  setBreadcrumbItems(items: BreadcrumbItem[]): void {
    this.breadcrumbItemsSubject.next(items);
  }

  clearBreadcrumbItems(): void {
    this.breadcrumbItemsSubject.next(null);
  }

  closeSidebar(): void {
    this.sidebarActionSubject.next({ action: 'close' });
  }
}
